<template>
  <b-modal
    id="delete-template-modal"
    ref="deleteTemplateModalRef"
    hide-footer
    title="Remove template"
    @hide="close"
  >
    <form class="needs-validation" @submit.prevent="handleDeleteTemplate">
      <div class="form-group">
        <p>
          Are you sure you want to remove the template
          <strong class="font-bold">« {{ template.name }} »</strong> from the collection?
        </p>
      </div>
      <div class="text-right">
        <button type="button" class="btn btn-light" @click="close">Cancel</button>
        <button type="submit" class="ml-2 btn btn-danger">
          Remove
          <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
        </button>

      </div>
    </form>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import utils  from "@/utils"

export default {
  name: 'FormDeleteTemplate',
  props: {
    collectionId: {
      type: Number,
      required: true,
    },
    template: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('templateCollection', {
      isLoading: (state) => state.isLoading,
    }),
  },
  methods: {
    ...mapActions('templateCollection', [
      'deleteTemplateFromCollection',
    ]),
    close() {
      this.$emit('close')
    },
    initModal() {
      this.$refs['deleteTemplateModalRef'].show()
    },
    async handleDeleteTemplate() {
      try {
        await this.deleteTemplateFromCollection({
          collectionId: this.collectionId,
          templateId: parseInt(this.template.id, 10),
        })
        this.close()
        this.$emit('refresh')
        utils.showToastSuccess('Template deleted successfully')
      } catch (error) {
        console.error('Error deleting template:', error)
        utils.showToastError(error.message || 'There is a problem while deleting template')
      }
    },
  },
  mounted() {
    this.initModal()
  },
}
</script>